import { Component } from 'components/notifications';

/** @ngInject */
export default function notificationsRouter($stateProvider) {
    const baseState = {
        url: '/notifications',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.notifications', baseState);
}



// WEBPACK FOOTER //
// ./app/components/notifications/notifications.router.js